import React from 'react';
import {
  useRecoilValue
} from 'recoil';
import { gameProgressState } from '../state';
import { Home } from './Home';
import { Game } from './Game';
import { Intro } from './Intro';
import { Result } from './Result';
import styled from 'styled-components';

const StyledMain = styled.div`

  background-color: transparent;
  max-width: 5000px;
  width: 100%;
  margin:auto;
  height: auto;
  position: relative;
  overflow: hidden;
  z-index: 1;
  padding: 10px 0px 30px 0px;
  @media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){
    max-height: 650px;
  }
`;

const Main = () => {
  const gameProgress = useRecoilValue(gameProgressState);

  let stateComp = null
  if (gameProgress === 'home') {
    stateComp = <Home />;
  } else if (gameProgress === 'intro') {
    stateComp = <Intro />;
  } else if (gameProgress === 'main') {
    stateComp = <Game />;
  } else if (gameProgress === 'result') {
    stateComp = <Result />;
  }

  return (
    <StyledMain>
      {stateComp}
    </StyledMain>
  );
};

export {
  Main
}
